export const SectionTypes = [
  {
    id: "video",
    title: "Video",
    icon: "ph-video-camera-duotone",
    color: "text-green-800",
    dark_color: "text-green-400",
    bg_color: "bg-green-100",
    dark_bg: "bg-gray-700",
    layouts: {
      layout1: {
        name: "Layout 1",
        text: "Classic layout, video on the right",
        icons: ["ph-text-align-left", "ph-video"],
        column: false,
      },
      layout2: {
        name: "Layout 2",
        text: "Text above and large video below",
        icons: ["ph-text-align-center", "ph-video"],
        column: true,
      },
      layout3: {
        name: "Layout 3",
        text: "Video only",
        icons: ["ph-video"],
        column: false,
      },
    },
  },
  {
    id: "image",
    title: "Image",
    icon: "ph-image-duotone",
    color: "text-yellow-800",
    dark_color: "text-yellow-400",
    bg_color: "bg-yellow-100",
    dark_bg: "bg-gray-700",
  },
  {
    id: "texts",
    title: "Reading Section",
    icon: "ph-book-open-duotone",
    color: "text-purple-800",
    dark_color: "text-purple-400",
    bg_color: "bg-purple-100",
    dark_bg: "bg-gray-700",
  },
  {
    id: "questions",
    title: "Questions and Answers",
    icon: "ph-question-duotone",
    color: "text-blue-800",
    dark_color: "text-blue-400",
    bg_color: "bg-blue-100",
    dark_bg: "bg-gray-700",
  },
  {
    id: "pdf",
    title: "PDF",
    icon: "ph-file-pdf-duotone",
    color: "text-blue-800",
    dark_color: "text-blue-400",
    bg_color: "bg-blue-100",
    dark_bg: "bg-gray-700",
  },
];
